// @ts-nocheck
import { createHandlerChainRunnerOptionalParameter, Handler } from "@toolkit/Modules/client-framework/HandlerCreator";

type HandlerType = Handler;

export const DispatchClearDraftParameter: HandlerType = props => {
    props.dispatch({
        type: "Greif/Pages/TrailerTrackingV2/ClearDraftParameter",
    });
};

export const chain = [DispatchClearDraftParameter];

const clearDraftParameter = createHandlerChainRunnerOptionalParameter(chain, {}, "ClearDraftParameter");
export default clearDraftParameter;
